// Enum
import PROFILES from "../../enums/ProfileEnum";

export const requiredFieldsForm = {
        [PROFILES.ADMIN_MP]: [
            'profile',
            'canManageUsers',
            'login',
            'firstName',
            'lastName',
            'email',
            'phoneNumber'
        ],
        [PROFILES.SUPER_USER]: [
            'buList',
            'clientList',
            'profile',
            'canManageUsers',
            'login',
            'firstName',
            'lastName',
            'email',
            'location',
            'phoneNumber'
        ],
        [PROFILES.USER]: [
            'profile',
            'canManageUsers',
            'shopList',
            'login',
            'firstName',
            'lastName',
            'email',
            'phoneNumber',
            'buList',
            'clientList'
        ],
        [PROFILES.ADMIN]: [
            'clientList',
            'profile',
            'canManageUsers',
            'login',
            'firstName',
            'lastName',
            'email',
            'phoneNumber',
            'location'
        ]
};

/*************************************************
 ******************* Validation *******************
 *************************************************/
/**
 *
 * Les fonctions de validations retournent:
 *      - undefined si valide
 *      - errorMessage si invalide
 *
 */

const validateBuList = (buList) => {
    return buList.some(bu => !bu || !bu.id) ? 'userForm.errors.internBu' : undefined;
};

const validateClientList = (clientList) => {
    return clientList.some(client => !client || !client.id) ? 'userForm.errors.internClient' : undefined;
};

const validateProfile = (profile) => {
    if (!Object.keys(PROFILES).map(function(key){return PROFILES[key]}).includes(profile)) {
        return 'userForm.errors.profile';
    }
    return undefined;
};

const validateUserManagement = (canManageUsers) => {
    return undefined;
};

const validateShopList = (shopList) => {
    return shopList.some(shop => !shop || !shop.id) ? 'userForm.errors.internShop' : undefined;
};

const validateLogin = (login) => {
    if (!login || login === '') {
        return 'userForm.errors.requiredField';
    } else if (login.length < 3 || login.length > 100) {
        return 'userForm.errors.incorrectFieldSize3_100';
    }
    return undefined;
};

const validateFirstName = (firstName) => {
    if (!firstName || firstName === '') {
        return 'userForm.errors.requiredField';
    } else if (firstName.length < 1 || firstName.length > 45) {
        return 'userForm.errors.incorrectFieldSize1_45';
    }
    return undefined;
};

const validateLastName = (lastName) => {
    if (!lastName || lastName === '') {
        return 'userForm.errors.requiredField';
    } else if (lastName.length < 1 || lastName.length > 45) {
        return 'userForm.errors.incorrectFieldSize1_45';
    }
    return undefined;
};

const validateEmail = (email) => {
    if (!email || email === '') {
        return 'userForm.errors.requiredField';
    } else if (email.length < 5 || email.length > 100) {
        return 'userForm.errors.incorrectFieldSize5_100';
    } else if (!email.match('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')) {
        return 'userForm.errors.email';
    }
    return undefined;
};

const validatePhoneNumber = (phoneNumber) => {
    const phoneNumberRegex = "^(\\+)?(?:\\s*\\d){9,14}$"
    const matchingRegex = phoneNumber.match(phoneNumberRegex)
    if (phoneNumber && ((!matchingRegex || (matchingRegex && matchingRegex[0] !== phoneNumber)) || phoneNumber.trim().length === 0)) {
        return 'userForm.errors.phoneNumber'
    }
    return undefined
}

export const validateField = {
    'buList': validateBuList,
    'clientList': validateClientList,
    'profile': validateProfile,
    'canManageUsers': validateUserManagement,
    'shopList': validateShopList,
    'login': validateLogin,
    'firstName': validateFirstName,
    'lastName': validateLastName,
    'email': validateEmail,
    'phoneNumber': validatePhoneNumber,
    'location': () => { return undefined }
};

export const getFieldData = {
    'buList': {key: 'idBuList', getValue: (buList) => (buList.map(bu => bu.id))},
    'clientList': {key: 'idClientList', getValue: (clientList) => (clientList.map(client => client.id))},
    'profile': {key: 'profile', getValue: (profile) => (profile)},
    'canManageUsers': {key: 'canManageUsers', getValue: (canManageUsers) => (canManageUsers)},
    'shopList': {key: 'idShopList', getValue: (shopList) => (shopList.map(shop => shop.id))},
    'login': {key: 'login', getValue: (login) => (login)},
    'firstName': {key: 'firstName', getValue: (firstName) => (firstName)},
    'lastName': {key: 'lastName', getValue: (lastName) => (lastName)},
    'email': {key: 'email', getValue: (email) => (email)},
    'phoneNumber': {key: 'phoneNumber', getValue: (phoneNumber) => (phoneNumber)},
    'location': {key: 'location', getValue: (location) => (location)}
};



// WEBPACK FOOTER //
// ./src/components/userForm/UserFormUtils.js